import { RM08_04 } from "./RM08_04";

export const RM08_03 = {
  selectedValueColumn: "DrillKey",
  selectedTitle: "Territory",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Territory",
        binding: {
          data: {
            columns: [
              {
                name: "Territory",
                columnName: "TerritoryName",
                width: "450px",
                align: "left",
                sortable: true
              },
              {
                name: "Agent Name",
                columnName: "AgentName",
                width: "300px",
                align: "left",
                sortable: true
              },
              {
                name: "Actual Visits",
                columnName: "Coverage",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Planned Visits",
                columnName: "Target",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Call Rate",
                columnName: "CallRate",
                width: "180px",
                align: "center",
                sortable: true,
                percent: true
              },
            ],
            title: "TerritoryName",
            endpoint: "RM08.3",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "RegionCode", value: "2026" },
              { key: "DrillKey", value: "" },
            ],
          },
          context: {
            point: {
              onClick: RM08_04,
            },
          },
        },
      },
    },
  ],
};